import PropTypes from 'prop-types';
import React, { Component } from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import { Link } from 'react-router-dom';
import { Col, Grid, Button } from 'react-bootstrap';

import styles from './PricingAreYouACreative.module.scss';

export default class PricingAreYouACreative extends Component {
  static propTypes = {
    className: PropTypes.string,
    gradient: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.oneOf(['left', 'right']),
    ]),
  };

  static defaultProps = {
    gradient: false,
  };

  constructor() {
    super();

    this.state = {
      visible: false,
    };
  }

  render() {
    const { className, gradient, ...rest } = this.props;

    const { visible } = this.state;

    return (
      <VisibilitySensor
        partialVisibility
        delayedCall
        minTopValue={visible ? 0 : 100}
        active={!visible}
        onChange={(isVisible) => this.setState({ visible: isVisible })}
      >
        <div
          className={
            (gradient
              ? styles.gradient +
                ' ' +
                (gradient === 'left'
                  ? styles.gradientLeft
                  : styles.gradientRight)
              : styles.noGradient) + (className ? ' ' + className : '')
          }
          {...rest}
        >
          <div className={styles.container}>
            <Grid>
              <Col xs={12} md={8} mdPush={2}>
                <h3
                  className={styles.title + (visible ? '' : ' ' + styles.hide)}
                >
                  Are you a creative or digital freelancer?
                </h3>
                <p
                  className={
                    styles.description + (visible ? '' : ' ' + styles.hide)
                  }
                >
                  It's free to sign up and build your portfolio.{' '}
                  <a href="/signup">Click here</a> to get started.
                </p>
                <p
                  className={
                    styles.description + (visible ? '' : ' ' + styles.hide)
                  }
                >
                  We also have a{' '}
                  <a href="/pricing/creative">Pro subscription</a> to help you
                  get more paid work opportunities by increasing your monthly
                  pitch limits, a Pro badge to increase buyer confidence, and
                  the ability to see who's viewed your portfolio.
                </p>
                <div
                  className={
                    styles.buttonContainer + (visible ? '' : ' ' + styles.hide)
                  }
                >
                  <Link to="/pricing/creative">
                    <Button bsStyle="success" className={styles.button}>
                      More about Pro
                    </Button>
                  </Link>
                </div>
              </Col>
            </Grid>
          </div>
        </div>
      </VisibilitySensor>
    );
  }
}
